import {
  effect,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  SOFTLINE_CONFIG_USER_CONTEXT_BAR_ACCOUNT,
  SOFTLINE_WIDGET_SIDE_MENU_USER_INFO,
} from '@softline/application';
import { AuthenticationService } from '@softline/auth';
import { Store } from '@softline/core';
import { SOFTLINE_CONFIG_WIDGETS } from '@softline/ui-core';
import {
  SOFTLINE_CONFIG_CONTEXT_ACCOUNT,
  SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT,
  SOFTLINE_CONFIG_STORED_CONTEXT_FIELD,
  SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
  UtilitiesAccountStore,
} from '@softapps/core/context';
import { AccountContextEditorComponent } from './components/account-context-editor/account-context-editor.component';
import { AccountContextWidgetComponent } from './widgets/account-context-widget/account-context-widget.component';

export const accountContextProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    const authenticationService = inject(AuthenticationService, { optional: true });
    if (!authenticationService) return;
    // Load once authenticated instead of probing the JWT store: the
    // jwtAuthentication feature does not exist in BFF builds (boot error),
    // and the BFF session arrives async after boot.
    let loaded = false;
    effect(() => {
      if (loaded || !authenticationService.isAuthenticated()) return;
      loaded = true;
      void store.dispatch(
        SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
        UtilitiesAccountStore.actions.loadMany,
        {
          clear: true,
          queryParams: {},
        }
      );
    });
  }),
  {
    provide: SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT,
    useValue: AccountContextEditorComponent,
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_WIDGETS,
    multi: true,
    useValue: {
      outlet: SOFTLINE_WIDGET_SIDE_MENU_USER_INFO,
      component: AccountContextWidgetComponent,
    },
  },
  {
    provide: SOFTLINE_CONFIG_USER_CONTEXT_BAR_ACCOUNT,
    useValue: true,
  },
  {
    provide: SOFTLINE_CONFIG_CONTEXT_ACCOUNT,
    useValue: { widgetLinkColor: 'var(--colorLink)' },
  },
  { provide: SOFTLINE_CONFIG_STORED_CONTEXT_FIELD, useValue: 'accountid', multi: true },
];
